import { Button } from '@virtidev/toolbox';

export { Button };

export default Button;
